/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type Heart_heartPortfolioItems$ref = any;
type Heart_viewer$ref = any;
export type HeartWrapper_viewer$ref = any;
export type HeartWrapper_viewer = {
    readonly heartItemMatches?: ReadonlyArray<{
        readonly item: {
            readonly serviceId: string | null;
        } | null;
        readonly " $fragmentRefs": Heart_heartPortfolioItems$ref;
    } | null> | null;
    readonly " $fragmentRefs": Heart_viewer$ref;
    readonly " $refType": HeartWrapper_viewer$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any);
    return {
        "kind": "Fragment",
        "name": "HeartWrapper_viewer",
        "type": "Viewer",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "LocalArgument",
                "name": "selectedItemIds",
                "type": "[String]",
                "defaultValue": []
            },
            {
                "kind": "LocalArgument",
                "name": "loadPortfolioData",
                "type": "Boolean",
                "defaultValue": false
            },
            {
                "kind": "LocalArgument",
                "name": "userIds",
                "type": "[String]",
                "defaultValue": []
            }
        ],
        "selections": [
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "loadPortfolioData",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": "heartItemMatches",
                        "name": "portfolioItemMatches",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "itemIds",
                                "variableName": "selectedItemIds"
                            },
                            {
                                "kind": "Literal",
                                "name": "portfolioTypes",
                                "value": [
                                    "HEART"
                                ]
                            },
                            (v0 /*: any*/)
                        ],
                        "concreteType": "PortfolioItemV2",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Item",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "serviceId",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "Heart_heartPortfolioItems",
                                "args": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "Heart_viewer",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "loadPortfolioData",
                        "variableName": "loadPortfolioData"
                    },
                    (v0 /*: any*/)
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '7a3d6bbc9b109c7bfec33046654b8d76';
export default node;
